import React, {
  useContext,
  useEffect,
  useMemo,
  useState,
  useCallback,
} from "react";
import ReactTable from "../../components/ReactTable/ReactTable.jsx";
import { config } from "../../config.js";
import { SidebarContext } from "../../context/SidebarContext";
import SectionMenuLeft from "../../components/SectionMenuLeft/SectionMenuLeft.jsx";
import "./Users.css"; // add skeleton styles here
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { LuArrowLeft } from "react-icons/lu";

function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isSidebar, adminPermissions } = useContext(SidebarContext);
  const [previewImage, setPreviewImage] = useState(null);
  const navigate = useNavigate();
  const openImageModal = (img) => {
    setPreviewImage(img);
  };

  const closeImageModal = () => {
    setPreviewImage(null);
  };
  const getUsers = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch(`${config.backEndBaseUrl}user/get`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-dashboard-request": "true",
        },
      });

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const result = await response.json();
      if (result.status && Array.isArray(result.users)) {
        setUsers(result.users);
      } else {
        setUsers([]);
      }
    } catch (error) {
      console.error("Fetching users failed:", error);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  const handleStatusUpdate = (uid, newStatus) => {
    setUsers((prev) =>
      prev.map((user) =>
        user.uid === uid ? { ...user, isActive: newStatus } : user,
      ),
    );
  };

  const ToggleButtonStatus = ({ uid, initialStatus, onUpdate }) => {
    const [status, setStatus] = useState(initialStatus);
    const role = localStorage.getItem("adminRole");

    const handleToggleStatus = async () => {
      if (adminPermissions?.user_edit || role === "admin") {
        const newStatus = !status;
        setStatus(newStatus);

        try {
          const response = await fetch(
            `${config.backEndBaseUrl}user/block/${uid}`,
            {
              method: "PUT",
              headers: { "Content-Type": "application/json" },
            },
          );

          if (!response.ok) throw new Error("Network response was not ok");
          if (onUpdate) onUpdate(uid, newStatus);
        } catch (error) {
          console.error("Error updating status:", error);
          setStatus(!newStatus);
        }
      } else {
        toast.error("You don't have permission to change user status.");
      }
    };

    return (
      <div className="toggle-container" onClick={handleToggleStatus}>
        <div className={`toggle-switch ${status ? "active" : ""}`}>
          <div className="toggle-knob"></div>
        </div>
        <span className={`toggle-text ${status ? "active" : ""}`}>
          {status ? "active" : "deactive"}
        </span>
      </div>
    );
  };

  const columns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "userName",
        Cell: ({ row }) => {
          const user = row.original;
          const img = user.photoURL || "/adminAssets/images/user_1.avif";

          return (
            <div className="user-cell">
              <img
                src={img}
                alt={user.userName}
                className="user-avatar"
                onClick={() => openImageModal(img)}
              />

              <div className="user-info">
                <div className="user-name">{user.userName}</div>
              </div>
            </div>
          );
        },
      },
      { accessorKey: "phoneNumber", header: "Number" },
      { accessorKey: "email", header: "Email" },
      {
        accessorKey: "isActive",
        header: "Status",
        Cell: ({ cell }) => (
          <ToggleButtonStatus
            uid={cell.row.original.uid}
            initialStatus={cell.getValue()}
            onUpdate={handleStatusUpdate}
          />
        ),
      },
    ],
    [],
  );

  return (
    <div className="body">
      <div id="wrapper">
        <div id="page">
          <div className="layout-wrap">
            <SectionMenuLeft />
            <div className="section-content-right">
              <div
                className="main-content"
                style={{ paddingLeft: isSidebar ? "280px" : "0px" }}
              >
                <div className="main-content-inner">
                  <div className="main-content-wrap">
                    <div className="tf-section">
                      <div className="wg-box" style={{ marginBottom: 20 }}>
                        <div className="flex items-center justify-between mb-12 flex-wrap gap-3">
                          <div className="flex items-center gap-3">
                            <button
                              className="back-btn flex items-center gap-2"
                              onClick={() => navigate("/")}
                            >
                              <LuArrowLeft size={16} />
                              {/* <span>Back</span> */}
                            </button>

                            <h5 className="fare-heading">Users Overview</h5>
                          </div>
                        </div>

                        {loading ? (
                          <div className="skeleton-table">
                            {[...Array(6)].map((_, i) => (
                              <div className="skeleton-row" key={i}>
                                <div className="skeleton skeleton-name"></div>
                                <div className="skeleton skeleton-photo"></div>
                                <div className="skeleton skeleton-phone"></div>
                                <div className="skeleton skeleton-email"></div>
                                <div className="skeleton skeleton-status"></div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <>
                            <ReactTable columns={columns} data={users} />
                            {previewImage && (
                              <div
                                className="image-modal-overlay"
                                onClick={closeImageModal}
                              >
                                <div className="image-modal-content">
                                  <img src={previewImage} alt="Preview" />
                                </div>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Users;
